var React = require('react');

function FooterOpeningTimes (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#323D74","fillRule":"evenodd"},[React.createElement("path",{"d":"M22 42C10.972 42 2 33.028 2 22S10.972 2 22 2s20 8.972 20 20-8.972 20-20 20m0-42C9.869 0 0 9.869 0 22s9.869 22 22 22 22-9.869 22-22S34.131 0 22 0","key":0}),React.createElement("path",{"d":"M21.9894 21H16v2h8V9h-2.0106z","key":1})]));
}

FooterOpeningTimes.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44"};

module.exports = FooterOpeningTimes;

FooterOpeningTimes.default = FooterOpeningTimes;
